import { IOrganization } from '@boma/client-shared';
import { createAction, props } from '@ngrx/store';

export const loadOrganization = createAction(
  '[Organizations] Load Organization'
);

export const loadOrganizationSuccess = createAction(
  '[Organizations] Load Organization Success',
  props<{ payload: IOrganization }>()
);

export const loadOrganizationFailure = createAction(
  '[Organizations] Load Organization Failure',
  props<{ error: any }>()
);

export const addOrganizationImage = createAction(
  '[Organizations] Add Organization Image',
  props<{ file: File }>()
)

export const addOrganizationImageSuccess = createAction(
  '[Organizations] Add Organization Image Success',
  props<{ imageId: string; file: File }>()
);

export const addOrganizationImageFailure = createAction(
  '[Organizations] Add Organization Image Failure',
  props<{ error: any }>()
);

export const updateOrganization = createAction(
  '[Organizations] Update Organization',
  props<{ organization: IOrganization }>()
);

export const updateOrganizationSuccess = createAction(
  '[Organizations]  Update Organization Success',
  props<{ organization: IOrganization }>()
);

export const updateOrganizationFailure = createAction(
  '[Organizations]  Update Organization Failure',
  props<{ error: any }>()
);